import { CommonFlags as c, DefaultColumns, EntityColumn, EntityDefinition, MicroMClient, ValuesObject } from "@mcurros2/microm";
import { AppSupervisorFilters } from "../AppSupervisorFilters/AppSupervisorFilters";
import { AppSupervisorPersonalFilters } from "../AppSupervisorPersonalFilters/AppSupervisorPersonalFilters";
import { ACTVerPersonalTienda } from "./ACTVerPersonalTienda";
import { ACTVerReportesPersonal } from "./ACTVerReportesPersonal";
import { ACTVerReportesTienda } from "./ACTVerReportesTienda";
import { PersonalLocalizacionViewInfoWindowRenderer } from "./PersonalLocalizacionViewInfoWindowRenderer";
import { PersonalLocalizacionViewMarkerRenderer } from "./PersonalLocalizacionViewMarkerRenderer";
import { TiendasViewInfoWindowRenderer } from "./TiendasViewInfoWindowRenderer";
import { TiendasViewMarkerRenderer } from "./TiendasViewMarkerRenderer";

const columns = () =>
(
    {
        c_personal_id: new EntityColumn<string>({ name: 'c_personal_id', type: 'char', length: 20, flags: c.PK, prompt: 'Personal Id' }),
        c_tienda_id: new EntityColumn<string>({ name: 'c_tienda_id', type: 'char', length: 20, flags: c.Edit, prompt: 'Tienda Id' }),
        i_autorizaciones: new EntityColumn<number>({ name: 'i_autorizaciones', type: 'int', flags: c.Edit, prompt: 'Autorizaciones' }),
        i_autorizaciones_total: new EntityColumn<number>({ name: 'i_autorizaciones_total', type: 'int', flags: c.Edit, prompt: 'Total' }),
        i_personal_presentes: new EntityColumn<number>({ name: 'i_personal_presentes', type: 'int', flags: c.Edit, prompt: 'Presentes' }),
        i_personal_ausentes: new EntityColumn<number>({ name: 'i_personal_ausentes', type: 'int', flags: c.Edit, prompt: 'Ausentes' }),
        i_personal_sin_reportar: new EntityColumn<number>({ name: 'i_personal_sin_reportar', type: 'int', flags: c.Edit, prompt: 'Sin Reportar' }),
        i_personal_total: new EntityColumn<number>({ name: 'i_personal_total', type: 'int', flags: c.Edit, prompt: 'Total' }),
        i_visitas_finalizadas: new EntityColumn<number>({ name: 'i_visitas_finalizadas', type: 'int', flags: c.Edit, prompt: 'Finalizadas' }),
        i_visitas_en_proceso: new EntityColumn<number>({ name: 'i_visitas_en_proceso', type: 'int', flags: c.Edit, prompt: 'En Proceso' }),
        i_visitas_sin_iniciar: new EntityColumn<number>({ name: 'i_visitas_sin_iniciar', type: 'int', flags: c.Edit, prompt: 'Sin Iniciar' }),
        i_visitas_total: new EntityColumn<number>({ name: 'i_visitas_total', type: 'int', flags: c.Edit, prompt: 'Total' }),
        i_total_personal_checkin: new EntityColumn<number>({ name: 'i_total_personal_checkin', type: 'int', flags: c.Edit, prompt: 'Personal Checkin' }),
        i_total_personal_sin_checkin: new EntityColumn<number>({ name: 'i_total_personal_sin_checkin', type: 'int', flags: c.Edit, prompt: 'Personal Sin Checkin' }),
        ...DefaultColumns()
    }
)

const views = () =>
(
    {
        apsp_brwStandard: { name: 'apsp_brwStandard', keyMappings: {} },
        apsp_brwPersonalLocalizacion: {
            name: 'apsp_brwPersonalLocalizacion', keyMappings: { c_personal_id: 0 },
            FiltersEntity: (client: MicroMClient, parentKeys?: ValuesObject) => new AppSupervisorFilters(client, parentKeys),
            mapMarkerRenderer: PersonalLocalizacionViewMarkerRenderer,
            mapInfoWindowRenderer: PersonalLocalizacionViewInfoWindowRenderer
        },
        apsp_brwPersonalLocalizacionPresentes: {
            name: 'apsp_brwPersonalLocalizacionPresentes', keyMappings: { c_personal_id: 0 },
            FiltersEntity: (client: MicroMClient, parentKeys?: ValuesObject) => new AppSupervisorPersonalFilters(client, parentKeys),
        },
        apsp_brwPersonalLocalizacionAusentes: {
            name: 'apsp_brwPersonalLocalizacionAusentes', keyMappings: { c_personal_id: 0 },
             FiltersEntity: (client: MicroMClient, parentKeys?: ValuesObject) => new AppSupervisorPersonalFilters(client, parentKeys),
        },
        apsp_brwPersonalLocalizacionSinReportar: {
            name: 'apsp_brwPersonalLocalizacionSinReportar', keyMappings: { c_personal_id: 0 },
            FiltersEntity: (client: MicroMClient, parentKeys?: ValuesObject) => new AppSupervisorPersonalFilters(client, parentKeys),
        },
        apsp_brwTiendas: {
            name: 'apsp_brwTiendas', keyMappings: { c_tienda_id: 0 },
            FiltersEntity: (client: MicroMClient, parentKeys?: ValuesObject) => new AppSupervisorFilters(client, parentKeys),
            mapMarkerRenderer: TiendasViewMarkerRenderer,
            mapInfoWindowRenderer: TiendasViewInfoWindowRenderer
        },
        apsp_brwTiendasPersonal: { name: 'apsp_brwTiendasPersonal', keyMappings: { c_tienda_id: 0 } },
    }
)

const clientActions = () =>
(
    {
        ACTVerReportesPersonal: ACTVerReportesPersonal,
        ACTVerReportesTienda: ACTVerReportesTienda,
        ACTVerPersonalTienda: ACTVerPersonalTienda
    }
)

export class AppSupervisorDef extends EntityDefinition {

    columns = columns();
    views = views();
    clientActions = clientActions();

    constructor() {
        super('AppSupervisor');
    }
}